import type { SurveyImageAnswerValue } from '@coorum-research/shared-common/types/answer.type'
import type { QuestionFileModelData } from '@coorum-research/shared-common/types/survey-json.type'
import type { Question } from 'survey-core'
import type { ISurveyCreator } from 'survey-react-ui'

import { SurveyQuestion } from 'survey-react-ui'

type Props = {
  creator: ISurveyCreator
  question: Question
}

/**
 * answer 回答表示用のコンポーネント
 * question type === 'file'
 */
export function SurveyQuestionAnswerFile({ creator, question }: Props) {
  const modelData = question.toJSON() as QuestionFileModelData

  const value = Array.isArray(question.value) ? question.value as SurveyImageAnswerValue[] : []
  const isBarcodeVisible = modelData.usage === 'barcodeImage' && value.length > 0 && 'barcode' in value[0]
  const barcode = value[0]?.barcode

  return (
    <>
      {SurveyQuestion.renderQuestionBody(creator, question)}
      {isBarcodeVisible && (
        <p className="!mt-2 text-sm">
          商品名:
          {' '}
          {barcode?.product}
          <br />
          ブランド名:
          {' '}
          {barcode?.brand}
        </p>
      )}
      {modelData.showCommentArea && question.comment.length > 0 && <div className="mt-2">{question.comment}</div>}
    </>
  )
}
